import {Component, NgModule, OnInit, ViewChild, ElementRef} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import { Router} from "@angular/router";

import {MamMenuVerticalComponent} from './mam_app_vertical.menu';
import {MamAdminService} from './service/mam_service.component';

import { CookieService } from 'angular2-cookie/core';
import {DatexPipe} from "./pipe/datex.pipe";
import {TranslatePipe, TranslateServiceForm} from "./translate";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "./translate/translate.module.pipe"; // ADD THIS


@Component({
  selector: 'app-contents',
  template:`
    <!-- header : S -->
    <p class="sessionTime">{{'LANG_RetainSessionTime' | translate}} :  <span #dataContainer></span></p>
    <div class="header">
        <h1 class="logo"><a href="#">EXAFE MDM</a></h1>
      <ul class="userinfo">
        <li class="user"><strong>{{userID}}</strong> ({{companyName}})</li>
        <li class="iptime">{{'LANG_LastAccessIp' | translate}} : {{lastAccessIp}}<em>|</em>{{'LANG_LastAccessTime' | translate}} : {{lastAccessTime | datex: 'YYYY-MM-DD HH:mm:ss'}}</li>
      </ul>
      <a href="#" class="logout">{{'LogOut' | translate}}</a>
    </div>
    <!-- header : E -->

    <!-- lnbArea : S -->
    <div class="lnbArea">
      <app-menu-vertical></app-menu-vertical>
    </div>
    <!-- lnbArea : E -->

    <!-- content : S -->
    <div class="content">    
      <router-outlet></router-outlet>
    </div>
    <!-- content : E -->
 `
})
export class MamContentsComponent implements OnInit{

    private datePipe : any = new DatePipe("en");

    private LANG_WelcomeLogin:string;
    private LANG_LastAccessIp:string;
    private LANG_LastAccessTime:string;
    private LANG_RetainSessionTime:string;

    private userID:string;
    private companyName:string;
    private lastAccessIp:string;
    private lastAccessTime:string;

    static timer_sessionMaxInactiveInterval:number = 0;
    static timer_checkTime:number = 0;
    private timer_period:number = 1;
    private timer_change_count:number = 0;

    private intervalTimer:any;
    checkTime : any;
    @ViewChild('dataContainer') dataContainer: ElementRef;


    constructor(private  router: Router, private service: MamAdminService, private cookie : CookieService, private _translate: TranslateServiceForm, private logger : Logger){
      //clearInterval(this.intervalTimer);
      _translate.use("ko");
      this.getUserInfo();
    }

    ngOnInit() {

    }

    logout(event){
      clearInterval(this.intervalTimer);
      this.setDefaultSessionTimes();
      this.logOutAction();
      this.router.navigate(["/login"]);
    }

    getUserInfo() {
      this.service.getUserInfo().subscribe(
          value => {
              let session = value.user;

              if(value.user) {
                this.cookie.put('roleType', String(value.user.roleType));
                this.cookie.put('adminId' , value.user.username);
                this.cookie.put('companyId', String(value.user.company.id));
                this.cookie.put('companyType', String(value.user.company.companyType));
                this.userID = session.username;
                this.companyName = session.company.name;
                this.lastAccessIp = session.lastAccessIp;
                this.lastAccessTime = session.lastAccessTime;
                this.logoutSessionCheck ();
              }
            },
            () => {
              this.logger.debug("cookie " ,this.cookie.get('roleType'));
              this.logger.debug("cookie " ,this.cookie.get('companyId'));
              this.logger.debug("cookie " ,this.cookie.get('companyType'));

            }
      )
    }

    private logoutSessionCheck () : void {
      this.service.getSessionConfig().subscribe(
          value => {
              MamContentsComponent.timer_sessionMaxInactiveInterval = value;
              MamContentsComponent.timer_checkTime = MamContentsComponent.timer_sessionMaxInactiveInterval;

              this.intervalTimer = setInterval(() => {

                if(MamContentsComponent.timer_checkTime== 0){
                    if(this.intervalTimer) {clearInterval(this.intervalTimer);
                        this.service.timeout().subscribe(
                            value => {
                                this.setDefaultSessionTimes();
                                clearInterval(this.intervalTimer);
                                clearImmediate(this.intervalTimer);
                            });
                    }
                    this.setDefaultSessionTimes();
                    return;
                }
                MamContentsComponent.timer_checkTime -= this.timer_period;
                this.dataContainer.nativeElement.innerHTML = MamContentsComponent.timer_checkTime;
                //this.logger.debug("checkTime", MamContentsComponent.timer_checkTime);

              }, this.timer_period * 1000);

            },
            () => {

            }
      )
    }

    private setDefaultSessionTimes () : void {
      MamContentsComponent.timer_sessionMaxInactiveInterval = 0;
      MamContentsComponent.timer_checkTime = 0;
      this.timer_period = 1;
      this.timer_change_count = 0;
    }


    logOutAction() {
      this.service.logOut().subscribe(
          value => {
            let result = value;

            this.logger.debug("logout result :", value);
          },
          error => {
            this.logger.error("-- error : " + error);
            this.logger.debug(error);
          },
          () => {

          }
      )
    }
}
@NgModule({
  imports:[],
  declarations:[MamContentsComponent, DatexPipe, TranslatePipe, TranslatePipeMoudle],
  exports:[MamContentsComponent],
  providers:[MamAdminService]
})
export class MamContentsModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/mam_contents.component.ts